import { render, staticRenderFns } from "./PopupCancelOrder.vue?vue&type=template&id=15daf35c&"
import script from "./PopupCancelOrder.vue?vue&type=script&lang=js&"
export * from "./PopupCancelOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports